import { useMutation } from '@apollo/client';
import { DISMISS_BANNER } from '../graphql/dismissBanner';

export const BannerTypes = {
  emailVerification: 'emailVerification',
  learnBuffer: 'learnBuffer',
  followBufferMastodon: 'followBufferMastodon',
  mastodonChannelPromo: 'mastodonChannelPromo',
  connectYoutubeChannel: 'connectYoutubeChannel',
  instagramStoryAspectRatio: 'instagramStoryAspectRatio',
  instagramStoriesPromo: 'instagramStoriesPromo',
};

const useDismissBanner = ({ banner }) => {
  const [dismissBanner] = useMutation(DISMISS_BANNER);

  const onDismissBanner = () => {
    if (!banner || !Object.values(BannerTypes).includes(banner)) {
      return;
    }

    dismissBanner({ variables: { banner } });
  };

  return { onDismissBanner };
};

export default useDismissBanner;
